import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import CategorySkeleton from "./CategorySkeleton";

const CategorySection = ({ category }) => {

  // Local cache logic
  const categoryData = useMemo(() => {
    const cached = localStorage.getItem("categories");
    if (cached) return JSON.parse(cached);

    if (category?.data?.data) {
      localStorage.setItem("categories", JSON.stringify(category.data.data));
      return category.data.data;
    }

    return [];
  }, [category]);

  return (
    <div className="container our-category">
      <h1>Our Painting Gallery</h1>

      {!categoryData.length ? (
        <CategorySkeleton />
      ) : (
        <div className="row">
          {categoryData.map((item) => (
            <div key={item.id} className="col-md-3 mb-4">
              <Link to={`/shop/${item.url}`}>
                <div className="item text-center">
                  <div className="circular-img-wrapper">
                    <img
                      src={item.image}
                      alt={item.name}
                      loading="lazy"
                      className="category-circle-img"
                    />
                  </div>
                  <h2>{item.name}</h2>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategorySection;
